/* @flow */

import getStore from '../preact-app/get-store';
import * as usuarioDuck from '../ducks/usuario';
import * as empresaDuck from '../ducks/empresa';

type Retorno = {
    nomeUsuario: string,
    logo: string,
    razaoSocial: string,
    cnpj: string,
};

const padrao = {
    logo: '',
    razaoSocial: '',
    cnpj: '',
};

const getDadosHeader = (): Retorno => {
    const state = getStore().getState();
    const nomeUsuario = usuarioDuck.getNome(state);
    const {
        logo,
        razaoSocial,
        cnpj,
    } = empresaDuck.getEmpresa(state) || padrao;

    return {
        nomeUsuario,
        logo: logo || '',
        razaoSocial,
        cnpj,
    };
};

export default getDadosHeader;
